export function convertItemFunction<T, U>(
    data: T[],
    setFunction: (converted: U[]) => void,
    transformFunction: (item: T) => U
): void {
    const items: U[] = data.map(transformFunction);
    setFunction(items);
}